(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  function loadProductRecommendationsIntoSection() {
    var productRecommendationsSection = document.querySelector('.product-recommendations');
    if (productRecommendationsSection === null) {
      return;
    };
    var productId = productRecommendationsSection.dataset.productId;
    var limit = productRecommendationsSection.dataset.limit;
    var requestUrl = Station.Theme.shop.root + 'recommendations/products?section_id=product-recommendations&limit='+limit+'&product_id=' + productId;
    var request = new XMLHttpRequest();
    request.open('GET', requestUrl);
    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement('div');
        container.innerHTML = request.response;
        productRecommendationsSection.parentElement.innerHTML = container.querySelector('.product-recommendations').innerHTML;
        window.Station.Theme.Currency.init();
        window.Station.Theme.Cart.init();
      };
    };
    request.send();
  };
  document.addEventListener('DOMContentLoaded', function (event) {
    loadProductRecommendationsIntoSection();
  });
  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail.sectionId === 'product-recommendations') {
      loadProductRecommendationsIntoSection();
    };
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smart-enclosure-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('[data-enclosure-slide]');if(!button)return;const root=button.closest('[data-enclosure]');const track=root.querySelector('.enclosure-track');track.scrollTo({left:track.clientWidth*Number(button.dataset.enclosureSlide),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smart-vortex-package-details"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-smart-vortex-package] [data-smart-vortex-add-to-cart]');
    if (!trigger || trigger.disabled) return;
    const mainButton = document.querySelector('article.smart-pdp-conversion-preview [data-smart-pdp-add-to-cart]');
    if (!mainButton || mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true') return;
    event.preventDefault();
    mainButton.click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smart-vortex-stanchion-details"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-smart-vortex-package] [data-smart-vortex-add-to-cart]');
    if (!trigger || trigger.disabled) return;
    const mainButton = document.querySelector('article.smart-pdp-conversion-preview [data-smart-pdp-add-to-cart]');
    if (!mainButton || mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true') return;
    event.preventDefault();
    mainButton.click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smart-vortex-stanchion-separate"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-smart-vortex-package] [data-smart-vortex-add-to-cart]');
    if (!trigger || trigger.disabled) return;
    const mainButton = document.querySelector('article.smart-pdp-conversion-preview [data-smart-pdp-add-to-cart]');
    if (!mainButton || mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true') return;
    event.preventDefault();
    mainButton.click();
  });

  } catch(e) { console.error(e); }
})();
})();
